export const initialSkills = [
  { name: 'HTML5', iconKey: 'FaHtml5', color: '#e34f26' },
  { name: 'CSS3', iconKey: 'FaCss3Alt', color: '#1572b6' },
  { name: 'JavaScript', iconKey: 'FaJs', color: '#f7df1e' },
  { name: 'TypeScript', iconKey: 'SiTypescript', color: '#3178c6' },
  { name: 'React', iconKey: 'FaReact', color: '#61dafb' },
  { name: 'Next.js', iconKey: 'SiNextdotjs', color: '#ffffff' },
  { name: 'Tailwind', iconKey: 'SiTailwindcss', color: '#06b6d4' },
  { name: 'Framer Motion', iconKey: 'SiFramer', color: '#00d8ff' },
  { name: 'Node.js', iconKey: 'FaNodeJs', color: '#339933' },
  { name: 'MongoDB', iconKey: 'SiMongodb', color: '#47a248' },
  { name: 'PHP', iconKey: 'FaPhp', color: '#777bb4' },
  { name: 'MySQL', iconKey: 'SiMysql', color: '#4479a1' },
  { name: 'Python', iconKey: 'FaPython', color: '#3776ab' },
  { name: 'Git', iconKey: 'FaGitAlt', color: '#f05032' },
];

export const AVAILABLE_ICONS = [
  { key: 'FaHtml5', label: 'HTML5', defaultColor: '#e34f26' },
  { key: 'FaCss3Alt', label: 'CSS3', defaultColor: '#1572b6' },
  { key: 'FaJs', label: 'JavaScript', defaultColor: '#f7df1e' },
  { key: 'SiTypescript', label: 'TypeScript', defaultColor: '#3178c6' },
  { key: 'FaReact', label: 'React', defaultColor: '#61dafb' },
  { key: 'SiNextdotjs', label: 'Next.js', defaultColor: '#ffffff' },
  { key: 'SiTailwindcss', label: 'Tailwind CSS', defaultColor: '#06b6d4' },
  { key: 'SiFramer', label: 'Framer Motion', defaultColor: '#00d8ff' },
  { key: 'FaNodeJs', label: 'Node.js', defaultColor: '#339933' },
  { key: 'SiMongodb', label: 'MongoDB', defaultColor: '#47a248' },
  { key: 'FaPhp', label: 'PHP', defaultColor: '#777bb4' },
  { key: 'SiMysql', label: 'MySQL', defaultColor: '#4479a1' },
  { key: 'FaPython', label: 'Python', defaultColor: '#3776ab' },
  { key: 'FaGitAlt', label: 'Git', defaultColor: '#f05032' },
  { key: 'FaJava', label: 'Java', defaultColor: '#f89820' },
  { key: 'FaDocker', label: 'Docker', defaultColor: '#2496ed' },
  { key: 'FaAws', label: 'AWS', defaultColor: '#ff9900' },
  { key: 'SiFirebase', label: 'Firebase', defaultColor: '#ffca28' },
  { key: 'SiPostgresql', label: 'PostgreSQL', defaultColor: '#4169e1' },
  { key: 'SiRedux', label: 'Redux', defaultColor: '#764abc' },
  { key: 'SiGraphql', label: 'GraphQL', defaultColor: '#e10098' },
  { key: 'SiFigma', label: 'Figma', defaultColor: '#f24e1e' },
  { key: 'SiVite', label: 'Vite', defaultColor: '#646cff' },
  { key: 'SiExpress', label: 'Express', defaultColor: '#ffffff' },
  { key: 'SiPrisma', label: 'Prisma', defaultColor: '#2d3748' },
  { key: 'SiLinux', label: 'Linux', defaultColor: '#fcc624' },
  { key: 'SiFlutter', label: 'Flutter', defaultColor: '#02569b' },
];

const SKILLS_STORAGE_KEY = 'portfolio_custom_skills_v1';

export const getSkills = () => {
  try {
    const saved = localStorage.getItem(SKILLS_STORAGE_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return parsed;
      }
    }
  } catch (err) {
    console.error('Failed to load skills from localStorage:', err);
  }
  return initialSkills;
};

export const saveSkills = (skillsList) => {
  try {
    localStorage.setItem(SKILLS_STORAGE_KEY, JSON.stringify(skillsList));
    window.dispatchEvent(new Event('skills_updated'));
  } catch (err) {
    console.error('Failed to save skills to localStorage:', err);
  }
};

export const resetSkillsToDefault = () => {
  try {
    localStorage.removeItem(SKILLS_STORAGE_KEY);
    window.dispatchEvent(new Event('skills_updated'));
  } catch (err) {
    console.error('Failed to reset skills:', err);
  }
};
